import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, setBuyerAddress } from '../OwnershipTransferBuyerSlice';
import TextInput from '../../../Shared/TextInput/TextInput';
import { OwnershipTransferPrivateBuyerStep } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import AddressForm from '../../SaleJetBlock/Partials/AddressForm/AddressForm';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const CustomerAddress = (props) => {
    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            dwhGeneralReport({
                data: { ...props.data, userDetails: props.userDetails },
                actionType: DwhActionType.AddressPage,
                messageText: DWHMessageText.AddressPageDisplayed,
                status: DWHStatus.Ongoing
            });
        }
    }, []);
    const [isSubmit, setIsSubmit] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);

    async function setCustomerAddress(res) {
        setIsSubmit(false);
        const address = {
            city: res.selectedAddress.cityName,
            street: res.selectedAddress.streetName,
            houseNum: res.selectedAddress.home,
            zipCode: res.selectedAddress.zipCode,
            apartment: res.selectedAddress.apartment,
        };

        if (Object.values(address).some((value) => value.trim() !== '')) {
            dwhGeneralReport({
                data: { ...props.data, userDetails: props.userDetails },
                actionType: DwhActionType.AddressPage,
                messageText: DWHMessageText.AddressPageButtonClicked,
                status: DWHStatus.Ongoing
            });
            await props.setBuyerAddress(address);
            setShowErrorMsg(false);
            props.setCurrentStep(OwnershipTransferPrivateBuyerStep.PaymentData)
        }
        else {
            setShowErrorMsg(true);
        }
    }


    return (
        <div className='ownership-transfer-form ownership-transfer-step'>
            <div className='l-title center'>מה הכתובת?</div>
            <div className='m-title center'> אנחנו צריכים אותה כדי לפתוח לך חשבון</div>

            <div>
                <AddressForm
                    isSubmit={isSubmit}
                    onSubmit={(res) => setCustomerAddress(res)}
                    selectedAddress={{
                        cityName: props.data.subscriberPersonalData?.city ?? '',
                        streetName: props.data.subscriberPersonalData?.street ?? '',
                        home: props.data.subscriberPersonalData?.houseNum ?? '',
                        apartment: props.data.subscriberPersonalData?.apartment ?? '',
                    }}
                />
            </div>


            <div className='continue-button'>
                {showErrorMsg && <div className='error center'>כדי להמשיך יש למלא את כל שדות החובה</div>}
                <BtnSubmit onclick={() => setIsSubmit(true)} text={'אפשר להמשיך'} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    data: state.OwnershipTransferPrivateBuyer,
    userDetails: state.authentication?.loginData
});

const mapDispatchToProps = {
    setCurrentStep,
    setBuyerAddress,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAddress);
